import newsletterSignUp from '../newsletterSignUp'
import cmsSettings from '../cmsSettings'

export const fields = `
    _type,
    _key,
    cmsSettings {
      ${cmsSettings()}
    },
    sectionBackground,
    backgroundImage {
      asset-> {
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      }
    },
    content {
      ${newsletterSignUp.fields}
    }
  `

export const fragment = (name = 'newsletterSignUpSection') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
